import {clsx} from 'clsx'
import {useSlots} from '@primer/react/experimental'
import type {ReactNode, HTMLAttributes} from 'react'
import styles from './Header.module.css'
import {SidebarToggle} from './SidebarToggle'
import {useLayoutContext} from './layout-context'

export interface HeaderProps {
  children?: ReactNode
  className?: string
}

export interface HeaderLeftProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ReactNode
  className?: string
}

export interface HeaderRightProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ReactNode
  className?: string
}

/* <PacerLayout.HeaderLeft> */
export function HeaderLeft({children, className, ...props}: HeaderLeftProps) {
  return (
    <div className={clsx(styles.column, styles.leftColumn, className)} {...props}>
      {children}
    </div>
  )
}

/* <PacerLayout.HeaderRight> */
export function HeaderRight({children, className, ...props}: HeaderRightProps) {
  return (
    <div className={clsx(styles.column, styles.rightColumn, className)} {...props}>
      {children}
    </div>
  )
}

/* <PacerLayout.Header> */
export function Header({children, className, ...props}: HeaderProps) {
  const {slimLineTopTabs} = useLayoutContext()
  const [slots] = useSlots(children, {
    leftColumn: HeaderLeft,
    rightColumn: HeaderRight,
  })

  const hasColumns = slots.leftColumn && slots.rightColumn

  if (hasColumns) {
    return (
      <header className={clsx(styles.columnHeader, slimLineTopTabs && styles.slimLineTopTabs, className)} {...props}>
        <SidebarToggle />
        {slots.leftColumn}
        {slots.rightColumn}
      </header>
    )
  }

  return (
    <header className={clsx(styles.header, slimLineTopTabs && styles.slimLineTopTabs, className)} {...props}>
      <SidebarToggle />
      {children}
    </header>
  )
}
